<template>
  <layout title="Cookies Policy">
    <textFirstSection title="Cookies Policy" />
    <div class="flex justify-center p-6">
      <div class="mt-6 html-editor max-w-6xl mb-6">
        <h2>What are cookies?</h2>
        <p>
          Cookies are simple text files that are stored on your computer or
          mobile device by a website’s server. Each cookie is unique to your web
          browser. It will contain some anonymous information such as a unique
          identifier, website’s domain name, and some digits and numbers.
        </p>
        <h2>What types of cookies do we use?</h2>
        <h5><strong>Necessary cookies</strong></h5>
        <p>
          Necessary cookies allow us to offer you the best possible experience
          when accessing and navigating through our website and using its
          features. For example, these cookies let us recognize that you have
          created an account and have logged into that account.
        </p>
        <h5><strong>Functionality cookies</strong></h5>
        <p>
          Functionality cookies let us operate the site in accordance with the
          choices you make. For example, we will recognize your username and
          remember how you customized the site during future visits
        </p>
        <h2>How to delete cookies?</h2>
        <p>
          If you want to restrict or block the cookies that are set by our
          website, you can do so through your browser setting. Alternatively,
          you can visit
          <a href="https://www.internetcookies.org" target="_blank"
          rel="noreferrer"
            >www.internetcookies.org</a
          >, which contains comprehensive information on how to do this on a
          wide variety of browsers and devices. You will find general
          information about cookies and details on how to delete cookies from
          your device.
        </p>
        <h2>Contacting us</h2>
        <p>
          If you have any questions about this policy or our use of cookies,
          please contact Youverse at
          <a href="mailto:support@youverse.id">support@youverse.id</a>.
        </p>
      </div>
    </div>
  </layout>
</template>

<script>
const layout = () => import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");
const textFirstSection = () => import(/* webpackChunkName: "textFirstSection" */ "../Components/Layout/textFirstSection.vue");
export default {
  components: { layout, textFirstSection },
};
</script>

<style>
  @import '../../css/custom.css';
</style>